import * as React from 'react';
import { RvDataTopicInfo } from './DataTopicInfo';
import { MatterTopicData } from './MatterDataTopicInfo';
import { ThemeProvider } from 'glamorous';
import { mainTheme } from '../../Theme';

export interface DataTopicInfoCardProps {
    title?: string;
    description?: string;
    data: Array<MatterTopicData>;
}

export class RvDataTopicInfoCard extends React.Component<DataTopicInfoCardProps, {}>  {

    public render() {
        return (
            <ThemeProvider theme={mainTheme}>
                <RvDataTopicInfo
                        description={this.props.description}
                        data={this.props.data}
                />
            </ThemeProvider>
        );
    }
}